<template>
  <Modal
    :title="$t('customize_text_block')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise` }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <MarkdownInput
      v-model="form.synopsis"
      :label="$t('text')"
      name="synopsis"
      rows="12"
    />
  </Modal>
</template>

<script setup lang="ts">
import type { TextBlock } from '~/types/blocks'

const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<TextBlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  synopsis: data.value.item.synopsis
})
</script>
